import React from 'react'
import { LocalizationProvider } from '@material-ui/pickers'
import MomentUtils from '@material-ui/pickers/adapter/moment'

const CaldndarProvider = (props) => {
	return <LocalizationProvider dateAdapter={MomentUtils} {...props} />
}
export default CaldndarProvider
